<script lang="ts" setup></script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.03544 4.00024H8H6C5.44772 4.00024 5 4.44796 5 5.00024C5 5.55253 5.44772 6.00024 6 6.00024V20.0002C6 21.1048 6.89543 22.0002 8 22.0002H17C18.1046 22.0002 19 21.1048 19 20.0002V6.00024C19.5523 6.00024 20 5.55253 20 5.00024C20 4.44796 19.5523 4.00024 19 4.00024H17H15.9646C15.7219 2.3041 14.2632 1.00024 12.5 1.00024C10.7368 1.00024 9.27806 2.3041 9.03544 4.00024ZM13.9146 4.00024C13.7087 3.41765 13.1531 3.00024 12.5 3.00024C11.8469 3.00024 11.2913 3.41765 11.0854 4.00024H13.9146ZM8 20.0002V6.00024H17V20.0002L8 20.0002ZM9.5 8.00024H11.5V18.0002H9.5V8.00024ZM15.5 8.00024H13.5V18.0002H15.5V8.00024Z"
      fill="currentColor"
    />
  </svg>
</template>
